import { render, staticRenderFns } from "./OptionDetailList.vue?vue&type=template&id=a090fdb0&scoped=true"
import script from "./OptionDetailList.vue?vue&type=script&lang=js"
export * from "./OptionDetailList.vue?vue&type=script&lang=js"
import style0 from "./OptionDetailList.vue?vue&type=style&index=0&id=a090fdb0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a090fdb0",
  null
  
)

export default component.exports